import { SYSTEM_DEFINED_SPI_IDS, SPI_BEST_METRICS } from '@src/utils/kpi';

export const isKpiValid = (selectedKpi) => {
  const kpiID = selectedKpi?.kpiID ?? 1;
  const isKpiFound = SYSTEM_DEFINED_SPI_IDS.some((value) => value === kpiID);
  return isKpiFound;
};
// For selected row on the BenchmarkTable SPIBEST metrics are needed
// These metrics are used only by benchmark gateway we filter the supported best metric from metric map
// This method returns the benchmark metric from the list
export const benchmarkMetricFinder = (selectedMetric: any) => {
  const findSPIBestMetric = SPI_BEST_METRICS.find((element: string) => {
    if (element.includes(selectedMetric)) {
      return true;
    }
  });
  return findSPIBestMetric;
};
